// images
import NoImage from "../asset/image/no-image.png";

export const imageError = (e) => e.target.src = NoImage;